<template>
  <div class="stepModal position-relative">
    <div class="modal fade" id="activateCFModal" tabindex="-1" role="dialog" aria-labelledby="activateCFModal">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title fw-600" id="notesModalHeader">Activate Cloudflare Enterprise{{taskInfo.planName}}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <h4 class="mb-10 mt-0">Plan Selection</h4>
            </div>
            <div class="row">
              <div class="col-md-12 d-flex align">
                <input v-model="selectedPlan" class="make-cursor-pointer" type="radio" checked id="option1" name="options" value="performance_package">
                <label for="option1" class="mb-0 ml-5 fs-16 make-cursor-pointer">Performance Package</label>
              </div>
            </div>
            <div class="row mt-8">
              <div class="col-md-12 d-flex align">
                <input disabled v-model="selectedPlan" class="make-cursor-pointer" type="radio" checked id="option2" name="options" value="security_package">
                <label for="option2" class="mb-0 ml-5 fs-16 make-cursor-pointer">Security Package</label>
              </div>
            </div>
            <div class="row mt-8">
              <div class="col-md-12 d-flex align">
                <input v-model="selectedPlan" class="make-cursor-pointer" type="radio" checked id="option3" name="options" value="performance_and_security_package">
                <label for="option3" class="mb-0 ml-5 fs-16 make-cursor-pointer">Performance & Security Package</label>
              </div>
            </div>
            <div class="row mt-8">
              <div class="col-md-12 d-flex align">
                <input disabled v-model="selectedPlan" class="make-cursor-pointer" type="radio" checked id="option4" name="options" value="maintenance_I">
                <label for="option4" class="mb-0 ml-5 fs-16 make-cursor-pointer">Maintenance I</label>
              </div>
            </div>
            <div class="row mt-8">
              <div class="col-md-12 d-flex align">
                <input disabled v-model="selectedPlan" class="make-cursor-pointer" type="radio" checked id="option5" name="options" value="maintenance_II">
                <label for="option5" class="mb-0 ml-5 fs-16 make-cursor-pointer">Maintenance II</label>
              </div>
            </div>
            <div class="row mt-8">
              <div class="col-md-12 d-flex align">
                <input disabled v-model="selectedPlan" class="make-cursor-pointer" type="radio" checked id="option6" name="options" value="maintenance_III">
                <label for="option6" class="mb-0 ml-5 fs-16 make-cursor-pointer">Maintenance III</label>
              </div>
            </div>
            <div class="row mt-8">
              <div class="col-md-12 d-flex align">
                <input v-model="selectedPlan" :disabled="taskInfo && (!taskInfo.planName.includes('Journey') && !taskInfo.planName.includes('Mediavine'))" class="make-cursor-pointer" type="radio" checked id="option7" name="options" value="mediavine_integration">
                <label for="option7" class="mb-0 ml-5 fs-16 make-cursor-pointer">Mediavine Integration</label>
              </div>
            </div>
            <div class="row mt-8">
              <div class="col-md-12 d-flex align">
                <input v-model="selectedPlan" class="make-cursor-pointer" type="radio" checked id="option8" name="options" value="boost">
                <label for="option8" class="mb-0 ml-5 fs-16 make-cursor-pointer">Boost</label>
              </div>
            </div>
            <div class="row mt-8">
              <div class="col-md-12 d-flex align justify-content-end">
                <button @click="activateCf" :disabled="!selectedPlan" class="btn btn-sm btn-primary"><span v-if="!activateCFLoader">Activate</span><i v-else class="fa fa-spin fa-spinner"></i></button>
              </div>
            </div>

            <hr v-if="taskInfo.cloudflare">
            <div v-if="taskInfo.cloudflare" class="row">
              <div class="col-md-12">
                <span class="fw-600 fs-18">DNS ACCESS:</span>
                <span v-if="verifyDNSLoader"><i class="fa fa-spin fa-spinner text-primary ml-10"></i></span>
                <template v-else>
                  <span v-if="dnsVerification" class="text-success ml-10 fw-600 fs-16">True 🤩</span>
                  <span v-else class="text-danger ml-10 fw-600 fs-16">False 😔</span>
                </template>
              </div>
            </div>
            <div v-if="taskInfo.cloudflare" class="row mt-15">
              <div class="col-md-12">
                <span class="fw-600 fs-18">NAMESERVERS:</span>
                <span v-if="verifyNameserverLoader"><i class="fa fa-spin fa-spinner text-primary ml-10"></i></span>
                <template v-else>
                  <span v-if="nameServerVerified" class="text-success ml-10 fw-600 fs-16">True 🤩</span>
                  <span v-else class="text-danger ml-10 fw-600 fs-16">False 😔</span>
                </template>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button data-dismiss="modal" aria-label="Close" class=" btn btn-sm btn-dark">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from '@/firebase/init'
import swal from "sweetalert2";
export default {
  name: "activateCFModal",
  data() {
    return {
      loading: false,
      selectedPlan: '',
      verifyDNSLoader: true,
      dnsVerification: false,
      verifyNameserverLoader: true,
      nameServerVerified: false,
      taskInfo: { planName: ''},
      activateCFLoader: false,
    }
  },
  computed: { //|| this.account === ''
    fieldsMissing () {
      if(this.account) {
        return (this.account.serverIP === ''
            || this.account.ftp.username === '' || this.account.ftp.password === ''|| this.account.phpMyAdmin.url === ''
            || this.account.phpMyAdmin.popupUsername === '' || this.account.phpMyAdmin.popupPassword === ''
            || this.account.phpMyAdmin.username === '' || this.account.phpMyAdmin.password === ''
            || this.account.cloudflare.username === '' || this.account.cloudflare.password === ''
            || this.account.cloudflare.userKey === '' || this.account.cloudflare.nameserver1 === ''
            || this.account.cloudflare.nameserver2 === '' || this.account.cloudflare.apiKey === ''
            || this.account.cloudflare.zone_id === '' )
      } else {
        return true
      }
    },
    user() {
      return this.$store.getters.user;
    },
  },
  methods: {
    async activateCf () {
      try {
        this.activateCFLoader = true
        if(this.taskInfo.from === 'cloudflare') {
          await db.collection('domains').doc(this.taskInfo.id).update({ cfPlan: this.selectedPlan, planName: this.taskInfo.planName });
          this.$http.post("provider/initiate_cf_pkey", {
            grant_type: "token",
            username: this.taskInfo.cloudflare.username,
            apiKey: this.taskInfo.cloudflare.apiKey,
            docId: this.taskInfo.id,
            initializedBy: `${this.user.firstName} ${this.user.lastName}`
          })
        } else if(this.taskInfo.from === 'hostingAccount') {
          const domainRef = await db.collection('domains').where('domain', '==', this.taskInfo.domain).where('ip', '==',this.taskInfo.serverIP).limit(1).get()
          if (domainRef.size) {
            const {id} = domainRef.docs[0];
            const cfEnterprise = domainRef.docs[0].data().cfEnterprise || {}
            cfEnterprise.previousStatus = cfEnterprise.status || '';
            cfEnterprise.status = 'pending';
            delete cfEnterprise.steps;
            await db.collection('domains').doc(id).update({ cfEnterprise, cfPlan: this.selectedPlan, isNewCFReq: true });
          }
          console.log('done')
        } else {
          const domainRef = await db.collection('domains').where('domain', '==', this.taskInfo.domain).where('ip', '==', this.taskInfo.serverIP).limit(1).get();
          if(domainRef.size) {
            const {id} = domainRef.docs[0];
            const cfEnterprise = domainRef.docs[0].data().cfEnterprise || {}
            cfEnterprise.status = 'running'
            await db.collection('domains').doc(id).update({ cfEnterprise, cfPlan: this.selectedPlan });
            if(this.taskInfo.from === 'support') {
              await db.collection('bigScootsTasks').doc(this.taskInfo.docId).update({ activationDate: new Date().toISOString(), cfActivationInitiated: true})
            }
            this.$http.post("provider/initiate_cf_pkey", {
              grant_type: "token",
              username: this.taskInfo.cloudflare.username,
              apiKey: this.taskInfo.cloudflare.apiKey,
              docId: id,
              initializedBy: `${this.user.firstName} ${this.user.lastName}`
            })
          }
        }
        $('#activateCFModal').modal('hide')
        // swal('Success', 'You have successfully activated CF Enterprise.', 'success')
      } catch (e) {
        console.log(e.toString());
        // swal('Error', 'Something went wrong when activating CF Enterprise..', 'error')
      } finally {
        this.activateCFLoader = false
      }
    },
    async verifyNameservers () {
      try {
        const wpoNameServers = [];
        const {cloudflare, domain} = this.taskInfo;
        if(cloudflare && cloudflare.nameserver1){
          wpoNameServers.push(cloudflare.nameserver1)
        }
        if(cloudflare && cloudflare.nameserver2)
        {
          wpoNameServers.push(cloudflare.nameserver2)
        }
        let {data} = await this.$http.post('email/email-config/verify-dns', {
          cloudflare_email: cloudflare.username,
          cloudflare_api_key: cloudflare.apiKey,
          cloudflare_zone: cloudflare.zone_id,
          grant_type: 'token',
          domain,
          nameservers: wpoNameServers
        });
        console.log('response for Verify Nameservers',data.verified)
        this.nameServerVerified = data.verified || false
      } catch (e) {
        console.log(e.toString());
      } finally {
        this.verifyNameserverLoader = false
      }
    },
    async verifyCloudFlare () {
      try {
        const { cloudflare, domain } = this.taskInfo;
        let {data} = await this.$http.post('email/verify-cloudflare', {
          cloudflare_email: cloudflare.username,
          cloudflare_api_key: cloudflare.apiKey,
          cloudflare_zone: cloudflare.zone_id,
          grant_type: 'token',
          domain,
        });
        console.log('response for Cloud flare',data)
        this.dnsVerification= data.msg || false;
      } catch (e) {
        console.log(`error while veriying cloudflare ${e.toString()}`)
      } finally {
        this.verifyDNSLoader = false
      }
    },
    doCopy(text) {
      const textField = document.createElement('textarea');
      textField.innerText = text;
      document.body.appendChild(textField);
      textField.select();
      textField.focus(); //SET FOCUS on the TEXTFIELD
      document.execCommand('copy');
      textField.remove();
      console.log('should have copied ' + text);
      this.$notify({
        group: 'foo',
        title: 'Message',
        text: 'Copied!'
      });
    },
    async load (data) {
      this.selectedPlan = ''
      this.dnsVerification = false;
      this.verifyDNSLoader = true;
      this.nameServerVerified = false;
      this.verifyNameserverLoader = true;
      data.domain = data.domain.replace('\t', '')
      this.taskInfo = data;
      if(!data.uid) {
        const ref = await db.collection('users').where('email', '==', data.email).limit(1).get();
        if(ref.size) {
          data.uid = ref.docs[0].id;
        }
      }
      if(data.uid && (data.from === 'support' || data.from === 'cloudflare')) {
        const hostingAccountRef = await db.collection('hostingAccounts').doc(data.uid).get();
        if(hostingAccountRef.exists) {
          const { accounts }= hostingAccountRef.data();
          const obj = accounts.find(el => el.primary.domain === data.domain || !!el.addon.find(adon => adon.domain === data.domain));
          console.log('obj found', obj)
          if(obj) {
            if(obj.primary.domain === data.domain) {
              this.taskInfo = {...this.taskInfo, ...obj.primary}
            } else {
              const addon = obj.addon.find(el => el.domain === data.domain);
              addon.serverIP = obj.primary.serverIP
              if(addon) {
                this.taskInfo = {...this.taskInfo, ...addon}
              }
            }
          }
        }
      }
      console.log('task info', JSON.stringify(this.taskInfo))
      $('#activateCFModal').modal('show');
      $('.modal-backdrop').removeClass("modal-backdrop");
      this.verifyCloudFlare();
      this.verifyNameservers()
    }
  }
}
</script>

<style  lang="scss" scoped>
.overlap-text{
  width: 100%;
  word-break: break-all;
}
hr {
  &.h-3 {
    border-top: 3px solid rgba(0,0,0,.1);
  }
}
</style>
